import React from "react";
import "./BecameAlphaComp.scss";
const BecameAlphaComp = () => {
  const handleRedirect = (url) => {
    window.open(url, "_blank");
  };
  return (
    <div className="becameAlphaCompContainer">
      <div className="becameAlphaCompWrapper">
        <div className="descBox">
          <h2>Why Become an Analyst?</h2>
          <p>
            At Alpha Capital Group, we transform trading by viewing you not just as a trader, but as a crucial market analyst whose insights fuel our advanced strategies. Through demo trades, you
            generate valuable data that drives our decision-making. This partnership is simple yet profound: your expertise powers our platform, and together, we shape the future of trading with
            collective intelligence.
          </p>
        </div>
        <div className="redirectBtns">
          <button
            onClick={() => {
              handleRedirect("https://app.alphacapitalgroup.uk/");
            }}
            className="normalButton"
          >
            Start Your Evaluation{" "}
          </button>
          <button
            onClick={() => {
              handleRedirect("https://app.alphacapitalgroup.uk/");
            }}
            className="normalButton"
          >
            Take Your Free Trial
          </button>
        </div>
      </div>
    </div>
  );
};

export default BecameAlphaComp;
